import type { CrbTask } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { TasksApi } from 'api/TasksApi';
import { BANK_CRB_TASKS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

/** One account's tasks, internal and external, unfiltered — `useBankTasks` is the bank wide list. */
export function useBankCrbTasks(crbId: string) {
  const { userBankId } = useUser();
  const tasksApi = new TasksApi();

  const { data: crbTasks, isLoading: isLoadingCrbTasks } = useQuery<CrbTask[]>({
    enabled: !!userBankId && !!crbId,
    queryKey: [BANK_CRB_TASKS_KEY, userBankId, crbId],
    queryFn: async () => {
      const response = await tasksApi.getBankCrbTasks(userBankId, crbId);
      return response.tasks;
    },
    meta: {
      snackbarErrorMessage:
        'There was an issue loading tasks. Please contact support if the problem persists.'
    }
  });

  return { crbTasks, isLoadingCrbTasks };
}
